const isDev = location.hostname.includes("dev-");
const DOMAIN_PREFIX = isDev ? "dev" : "";
// 用户中心暂未境内外分离
const chinaHost = `https://${DOMAIN_PREFIX}aw.aoscdn.com`;
const overseaHost = `https://${DOMAIN_PREFIX}gw.aoscdn.com`;
const host = document.documentElement.lang === "zh" ? chinaHost : overseaHost;
window.apiHost = window.apiHost || host;

let anonymousToken;
async function getAnonymousSession() {
  if (anonymousToken) return anonymousToken;
  const url = `https://${DOMAIN_PREFIX}gw.aoscdn.com/base/passport/v1/api/login`;
  const result = await (
    await fetch(url, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        brand_id: 29,
        app_id: 363,
        language: document.documentElement.lang || "en",
        type: 27,
        device_hash: "xxxwebdevicehashxxxxxxxxxxxxxxxx",
        platform: 2,
        os_name: "HONOR",
        os_version: "9",
      }),
    })
  ).json();
  anonymousToken = result.data?.api_token;
  return anonymousToken;
}
getAnonymousSession();

async function getApiTokenFromStorage() {
  const keys = ["passport_api_token", "account_api_token", "apiToken"];
  for (let key of keys) {
    const value = localStorage.getItem(key);
    if (value) {
      return `Bearer ${value}`;
    }
  }
  const anonymousToken = await getAnonymousSession();
  return `Bearer ${anonymousToken}`;
}

const actions = {
  common(body) {
    body.source_resource_id = body.resource_id || body.image_resource_id;
    const track = body.track;
    if (track) {
      for (let key in track) {
        body[key] = track[key];
      }
    }
  },
  "matting:create": function (body) {
    if (body.type) {
      body.type = {
        person: 1,
        object: 2,
        stamp: 3,
      }[body.type];
    }
  },
  "scale:create": function (body) {
    if (body.type) {
      body.type = body.type === "face" ? 2 : 1;
    }
    if (body.fix_face_only) {
      body["face_type"] = body.fix_face_only;
      delete body.fix_face_only;
    }
  },
};

const resultActions = {
  "matting:result": function (body) {
    const data = body.data;
    if (data && data.type) {
      data["result_type"] = {
        1: "person",
        2: "object",
        3: "stamp",
      }[data.type];
    }
  },
  "oss:upload": function (body) {
    const data = body.data;
    if (data && data.width) {
      data["file_info"] = {
        width: data.width,
        height: data.height,
      };
    }
  },
};

// api host 由 技术中台更换为 picwish golang service

const proto = {
  set onreadystatechange(val) {
    super.onreadystatechange = () => {
      if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
        try {
          const isBuffer = typeof this.response !== "string";
          if (!isBuffer) {
            const responseText = this.responseText;
            const responseData = JSON.parse(responseText);
            const actionName = this.getActionName();
            const action = resultActions[actionName] || Function.prototype;
            action(responseData);
            ["response", "responseText"].forEach((key) => {
              Object.defineProperty(this, key, {
                value: JSON.stringify(responseData),
              });
            });
          }
        } catch (e) {
          console.log(`hijack parse response error`);
        }
      }
      val();
    };
  },
  updateUrl(url) {
    url = url.replace("tech", "app/picwish");
    // 抠图
    url = url.replace(/tasks\/visual/, "tasks");
    // 去水印
    url = url.replace("watermark", "watermarks/image");
    // 压缩
    url = url.replace("imgcompress", "image/compress");

    this.url = url.match(/^http/) ? new URL(url) : url;
    this.pathname = this.url.pathname;
    this.headers = {};
  },
  getActionName() {
    const pathname = this.pathname;
    // 抠图
    if (pathname.match(/tasks\/segmentation$/)) {
      return "matting:create";
    }
    if (pathname.match(/tasks\/segmentation\/.+/)) {
      return "matting:result";
    }
    // 变清晰
    if (pathname.match(/tasks\/scale$/)) {
      return "scale:create";
    }
  },
  open(method, url) {
    this.updateUrl(url);
    super.open(method, this.url.toString());
  },
  setRequestHeader(key, val) {
    if (key.toLowerCase() === "x-api-key") {
      return;
    } else {
      this.headers[key] = val;
      super.setRequestHeader(key, val);
    }
  },
  async send(data) {
    if (this.url.toString().match(/aoscdn\.com\/app/)) {
      this.setRequestHeader("Authorization", await getApiTokenFromStorage());
      let body;
      try {
        body = JSON.parse(data);
        const actionName = this.getActionName();
        actions["common"](body);
        const action = actions[actionName] || Function.prototype;
        action(body);
      } catch (e) {
        console.log(`parse error`);
      }

      super.send(body ? JSON.stringify(body) : data);
    } else {
      this.updateUrl(this.url.toString());
      super.send(data);
    }
  },
};

const oldXHR = XMLHttpRequest;
function HttpRequest() {
  const xhr = new oldXHR();
  const xhrProto = Object.getPrototypeOf(xhr);
  Object.setPrototypeOf(xhr, proto);
  Object.setPrototypeOf(proto, xhrProto);
  xhr.send = proto.send;
  xhr.open = proto.open;
  return xhr;
}

window.XMLHttpRequest = HttpRequest;
